import storesApi from '../api/storesApi'
import { useApiClient } from '../context/AppContext'
import { FetchStoresList } from '../types/FetchStoresList'
import { ILoadStoresList } from '../types/ILoadStoresList'
import IResourceLoader from '../types/IResourceLoader'
import { IDetails } from '../types/IStoreDetails'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'

const useStoresListLoader = (): [
  IResourceLoader<IDetails[]>,
  ILoadStoresList
] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IDetails[]>('Unable to load stores list')

  const loader = useCallbackRef<FetchStoresList>(() =>
    resource.load(async () => storesApi.getStores(apiClient))
  )

  return [resource, loader]
}

export default useStoresListLoader